import { createAction } from '@reduxjs/toolkit';

export const clearFreebets = createAction('betslip/freeBets/clearFreebets');
